import React from 'react';
import logo from '../../assets/logo.svg';
import { Text } from '@creditinfo-ui/atoms';

const EleringReturn: React.FC = () => {
  return (
    <div className="centered-box__container">
      <div className="centered-box__card">
        <div className="centered-box__card-inner">
          <img src={logo} alt="Creditinfo logo" className="centered-box__logo" />

          <Text message={{}} size="extraTitle" variant="viewTitle">
            Access granted
          </Text>
          <Text>You've given CreditInfo access to electricity meter info.</Text>
        </div>
      </div>
    </div>
  );
};

export default EleringReturn;
